// @flow

import Immutable from 'seamless-immutable'
import {
  COMPLIANCE_SET_UPDATES,
  COMPLIANCE_SHOW_LOADING,
  COMPLIANCE_GET_POSTS_SUCCESS,
  SHOW_POSTER
} from './actionTypes'

const initialState = Immutable({
  blogPosts: [],
  poster: null,
  posters: [],
  updates: []
})

export default function State(state = initialState, action) {
  const records = {}

  switch (action.type) {
    case COMPLIANCE_SHOW_LOADING:
      state = state.set('complianceLoading', action.payload)
      break

    case COMPLIANCE_GET_POSTS_SUCCESS:
      state = Immutable.set(state, 'blogPosts', action.payload.data)
      break

    case COMPLIANCE_SET_UPDATES:
      // Currently we receive this list as an array, need to store it as an object
      action.payload.data.filter((update) => !update.isDraft).map((item, index) => {
        const id = index + 1
        records[id] = { ...item, id }
      })

      state = Immutable.set(state, 'updates', records)
      break

    case SHOW_POSTER:
      return Immutable.merge(state, { poster: action.poster })

    default:
      break
  }

  return state
}
